module.exports = __webpack_public_path__ + "static/media/app_login_how.63593e7e.png";